module.exports = __webpack_public_path__ + "static/yanndanot-4ed2ba90504255d951f42f6fe544be1a.png";